import React from 'react';
import { SparklesIcon, ExternalLinkIcon } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="backdrop-blur-sm border-t border-slate-700 mt-12" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          
          {/* Left Side - Logo and Links */}
          <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <img 
                src="/logo-neuroforge.png" 
                alt="NeuroForge Logo" 
                className="h-12 w-12"
                onError={(e) => {
                  // Fallback to icon if logo not found
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'inline';
                }}
              />
                <img 
                src="/logo-neuroforge2.png" 
                alt="NeuroForge Logo" 
                className="h-12 w-12"
                onError={(e) => {
                  // Fallback to icon if logo not found
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'inline';
                }}
              />
            
              {/* Replaced SparklesIcon: <SparklesIcon className="h-8 w-8 text-cyan-400 hidden" /> */}
                <img
                  src="/NFLogo.png"
                  alt="NeuroForge Logo"
                  className="h-14 w-14 object-contain drop-shadow-lg"
                />
              <span className="text-xl font-bold text-white">NeuroForge</span>
            </div>

            {/* Links */}
            <div className="flex items-center space-x-6">
              <a
                href="https://web-runner.net/web-runner-apps/neuroforge/neuroforge-documentation.html"
                className="flex items-center space-x-1 text-slate-400 hover:text-cyan-400 transition-colors"
              >
                <span>Documentation</span>
                <ExternalLinkIcon className="h-3 w-3" />
              </a>

            {/* Support Link */}
            <a
              href="https://web-runner.net/my-account"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-1 text-slate-400 hover:text-cyan-400 transition-colors"
            >
              <span>Support</span>
              <ExternalLinkIcon className="h-3 w-3" />
            </a>
            </div>
          </div>

          {/* Right Side - Copyright and Support */}
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm">
            {/* Copyright */}
            <div className="text-slate-500">
              © {new Date().getFullYear()} NeuroForge by Web Runner. All rights reserved.
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
